import { useEffect, useState } from 'react';
import mustache from 'mustache';
import { useCustomComponentStateContext } from './useCustomComponentState';

declare global {
  interface Window {
    certonaRecs: unknown;
    certona: unknown;
  }
}

const useCertonaApi = (): unknown => {
  const { state } = useCustomComponentStateContext();
  const [rawCertonaData, setCertonaData] = useState<unknown>();

  const { urlTemplate, ...productRecommendationsCertona } =
    (state?.queryData?.retailerSettings?.productRecommendations?.type ===
      'CERTONA' &&
      state?.queryData?.retailerSettings?.productRecommendations) ||
    {};

  const { certonaSettings }: { certonaSettings?: unknown } =
    productRecommendationsCertona;

  const { pageContext } = state || {};

  useEffect(() => {
    if (!urlTemplate) return undefined;

    const date = new Date().valueOf();
    const certonaApiUrl = mustache.render(urlTemplate, {
      ...pageContext,
      date,
    });

    // global jsonp callback
    window.certonaRecs = (certonaRecs: unknown) => setCertonaData(certonaRecs);

    // certona needs the following variable for the `eval`ed script
    window.certona =
      certonaSettings && typeof certonaSettings === 'object'
        ? Object.entries(certonaSettings).reduce(
            (settingKeyValuePair, [key, value]) => ({
              ...settingKeyValuePair,
              [key]:
                typeof value === 'string'
                  ? mustache.render(value, pageContext)
                  : '',
            }),
            {},
          )
        : null;

    const script = document.createElement('script');
    script.src = certonaApiUrl;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [pageContext, certonaSettings, urlTemplate]);

  return rawCertonaData;
};

export default useCertonaApi;
